import { module } from 'angular';
import component from './gridstack.component';

import './gridstack.scss';

export default module('app.gridstack', [])
	.component('gridstack', component)
	.name;
